export const SOME_BUSINESS_ID_INVALID =
  'Some merchants are invalid, please review the data';
export const COUPON_CODE_LENGTH_MUST_BE_ALPHANUMERIC_BETWEEN_1_AND_20 =
  'Please enter a valid code (alphanumeric, max 20 characters)';
export const COUPON_EXPIRATION_DATE_REQUIRED =
  'Please select an expiration date';
export const COUPON_DISCOUNT_PERCENTAGE_INVALID_AMOUNT =
  'Please enter a valid numeric amount between 1-100';
export const COUPON_MAX_DISCOUNT_INVALID_AMOUNT =
  'Please enter a valid numeric amount between 1.000-100.000.000';
export const COUPON_ADDITIONAL_MONTH_INVALID =
  'Please enter a valid numeric amount between 1-12';
export const COUPON_QUANTITY_INVALID =
  'Please enter a valid numeric amount between 1-1.000.000';
export const COUPON_MERCHANTS_UNASSIGNED = 'Please assign some merchants';
export const COUPON_DISCOUNT_REWARD_OR_SUBSCRIPTION_EXTENSION_IS_REQUIRED =
  'At least discount reward or subscription extension must be enabled';
export const COUPON_ASSIGN_MERCHANTS_BUSINESS_ID_REQUIRED =
  "Please enter merchant's business ID";
